<template>
  <div class="wg-row">
    <wg-modal
      v-if="mergeContactDialog"
      :width="windowWidth > 700 ? '500px' : '90%'"
      @closeModal="mergeContactDialog = false"
    >
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "Merge contacts", "Fondi contatti") }}
        </div>
      </div>
      <merge-contact
        :mergeConfirmDialog="mergeConfirmDialog"
        :contact="contact"
        slot="body"
      ></merge-contact>
    </wg-modal>
    <wg-modal
      v-if="openLinkModal"
      :width="windowWidth > 700 ? '700px' : '90%'"
      @closeModal="openLinkModal = false"
    >
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "Add new link", "Aggiungi link") }}
        </div>
      </div>
      <world-add-link
        :element="contact"
        @save="saveLink"
        slot="body"
      ></world-add-link>
    </wg-modal>
    <wg-modal
      :width="windowWidth > 700 ? '700px' : '90%'"
      v-if="showNewDialog"
      :portal="true"
      @closeModal="showNewDialog = !showNewDialog"
      :confirmOnClose="true"
      :confirmOnCloseMsg="$anm22.strLang(lang, 'Cancel adding a new contact?', 'Annullare aggiunta contatto?')"
    >
      <div
        class="com-anm22-app-text-xl"
        slot="header"
      >{{ $anm22.strLang(lang, 'New contact', 'Nuovo contatto') }}</div>
      <world-contact-form
        slot="body"
        :mode="'new'"
        :contactRef="newCompanyContact"
        :title="false"
        @closeForm="showNewDialog = !showNewDialog"
        :afterSaveFn="openNewContact"
        :hasCompanyHinting="true"
      ></world-contact-form>
    </wg-modal>
    <template v-if="contact.workOwner">
      <wg-modal
        v-if="showTagDialog"
        :portal="true"
        :width="'400px'"
        @closeModal="showTagDialog = false"
      >
        <div
          class="com-anm22-app-text-xl"
          slot="header"
        >{{ $anm22.strLang(lang, 'Tags', 'Etichette') }}</div>
        <div slot="body" class="wg-row">
          <!-- Form di aggiunta -->
          <div class="wg-row" style="flex-wrap:nowrap;">
            <div class="color-select">
              <div class="wg-row color-selected" @click="showColors = !showColors">
                <div
                  :style="{height: '12px', width: '12px', borderRadius: '50%', backgroundColor: newTag.color}"
                ></div>
              </div>
              <div v-show="showColors" class="display-flex color-list">
                <div
                  v-for="(color,index) in tagColors"
                  :key="'color-'+index"
                  class="wg-row"
                  :title="color.name"
                  @click="selectColor(color.color);"
                >
                  <div :style="{backgroundColor: color.color}"></div>
                </div>
              </div>
            </div>
            <input
              class="com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Label', 'Etichetta')"
              style="margin:0 10px;"
              v-model="newTag.label"
            />
            <input
              type="button"
              class="small"
              :style="{opacity: newTag.label === '' || canAdd == false ? '0.7' : ''}"
              :disabled="newTag.label === '' || canAdd == false"
              :value="$anm22.strLang(lang, 'Add', 'Aggiungi')"
              @click="addTag()"
            />
          </div>
          <div class="wg-row" style="margin-top:20px;justify-content:center;s">
            <input
              class="com-anm22-app-input-text"
              type="text"
              :placeholder="$anm22.strLang(lang, 'Tag name...', 'Nome etichetta...')"
              @input="tagSelectFilterString = $event.target.value"
            />
          </div>
          <!-- Lista -->
          <div class="wg-row com-anm22-app-scrolling-panel tags-list">
            <div v-for="(tag,index) in tagsToSelect" :key="'tag-'+index" class="wg-row tag-select">
              <div class="display-flex color-selected">
                <div
                  :style="{height: '12px', width: '12px', borderRadius: '50%', backgroundColor: tag.color}"
                ></div>
              </div>
              <div class="wg-col wg-xs-12 wg-sm-12" @click="addTag(tag)">
                <div class="com-anm22-app-text-m" style="margin-left:10px;">{{ tag.label }}</div>
              </div>
              <div v-if="!offline" class="wg-col wg-xs-12 wg-sm-12">
                <img
                  class="com-anm22-app-img-fixed-height-s"
                  :src="$anm22.icons.getWorldIcon('deleteBlack')"
                  style="cursor:pointer;"
                  @click="deleteTag(tag)"
                />
              </div>
            </div>
          </div>
        </div>
      </wg-modal>
      <div class="wg-row">
        <div
          class="com-anm22-app-text-xxl"
        >{{ $anm22.strLang(lang, 'Tags', 'Etichette') }}</div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row">
        <div v-for="(tag,index) in contactTags" :key="'tag'+index" class="display-flex contact-tag">
          <div class="color-selected">
            <div
              :style="{height: '12px', width: '12px', borderRadius: '50%', backgroundColor: tag.color}"
            ></div>
          </div>
          <div class="com-anm22-app-text-m" style="margin-left:10px;">{{ tag.label }}</div>
          <div style="margin-left:10px;">
            <img
              class="com-anm22-app-img-fixed-height-s"
              :src="$anm22.icons.getWorldIcon('deleteBlack')"
              style="cursor:pointer;"
              @click="removeTag(tag)"
            />
          </div>
        </div>
        <input
          type="button"
          class="small add-tag"
          :value="$anm22.strLang(lang, '+ Add tag', '+ Aggiungi etichetta')"
          @click="openTagDialog()"
        />
      </div>
      <div class="vertical-height-div" style="height:24px;"></div>
    </template>
    <div class="wg-row details-box">
      <div class="wg-row">
        <div
          class="com-anm22-app-text-xxl"
        >{{ $anm22.strLang(lang, 'Contact details', 'Dettagli contatto') }}</div>
      </div>
      <div class="vertical-height-div" style="height:24px;"></div>
      <div class="wg-row" style="flex-direction:column;">
        <div class="wg-row detail-row">
          <img
            class="com-anm22-app-img-fixed-height-m"
            :src="$anm22.icons.getWorldIcon(contact.type == 2 ? 'workMaterial' : 'menuContacts')"
          />
          <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'ID', 'ID')}}</span>{{ contact.idContactsContact }}</div>
        </div>
        <div v-if="contact.code" class="wg-row detail-row">
          <img
            class="com-anm22-app-img-fixed-height-m"
            :src="$anm22.icons.getWorldIcon(contact.type == 2 ? 'workMaterial' : 'menuContacts')"
          />
          <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Code', 'Codice')}}</span>{{ contact.code }}</div>
        </div>
        <div v-if="contact.birthday" class="wg-row detail-row">
          <img
            class="com-anm22-app-img-fixed-height-m"
            :src="$anm22.icons.getWorldIcon('birthday')"
          />
          <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Birthday', 'Compleanno')}}</span>{{ contact.birthday | moment('DD/MM/YYYY') }}</div>
        </div>
        <div v-if="contact.phoneAreaCode && contact.phoneNumber" class="wg-row detail-row">
          <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('phone')" />
          <a :href="'tel:' + contact.phoneAreaCode + contact.phoneNumber">
            <div
              class="com-anm22-app-text-l"
            ><span class="detail-label">{{ $anm22.strLang(lang, 'Phone', 'Telefono')}}</span>{{ contact.phoneAreaCode + ' ' + contact.phoneNumber }}</div>
          </a>
        </div>
        <div v-if="contact.otherContacts.phones">
          <div
            v-for="(phone,index) in contact.otherContacts.phones"
            :key="'other-phone-'+index"
            class="wg-row detail-row"
            :title="phone.phoneAreaCode + ' ' + phone.phoneNumber"
          >
            <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('phone')" style="opacity:0" />
            <a :href="'tel:' + phone.phoneAreaCode + phone.phoneNumber">
              <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Phone', 'Telefono')}}</span>{{ phone.phoneAreaCode + ' ' + phone.phoneNumber }}</div>
            </a>
          </div>
        </div>
        <div v-if="contact.email" class="wg-row detail-row">
          <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('email')" />
          <a :href="'mailto:' + contact.email">
            <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'E-mail', 'E-mail')}}</span>{{ contact.email }}</div>
          </a>
        </div>
        <div v-if="contact.otherContacts.emails">
          <div
            v-for="(email,index) in contact.otherContacts.emails"
            :key="'other-email-'+index"
            class="wg-row detail-row"
            :title="email.address"
          >
            <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('email')" style="opacity:0" />
            <a :href="'mailto:' + email.address">
              <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'E-mail', 'E-mail')}}</span>{{ email.address }}</div>
            </a>
          </div>
        </div>
        <div v-if="contact.pec" class="wg-row detail-row">
          <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('email')" />
          <a :href="'mailto:' + contact.pec">
            <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'PEC', 'PEC')}}</span>{{ contact.pec }}</div>
          </a>
        </div>
        <div v-if="contact.company" class="wg-row detail-row">
          <img
            class="com-anm22-app-img-fixed-height-m"
            :src="$anm22.icons.getWorldIcon('workContact')"
          />
          <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Company', 'Azienda')}}</span>{{ contact.company }}</div>
          <img
            v-if="workContact"
            :src="$anm22.icons.getWorldIcon('openApp')"
            :title="$anm22.strLang(lang, 'Open contact', 'Apri contatto')"
            class="com-anm22-app-img-fixed-height-m"
            @click="openWorkContact"
            style="margin-left:20px;cursor:pointer;"
          />
        </div>
        <div v-if="workChannels && workChannels.length > 0" class="wg-row detail-row ic-center">
          <img :title="$anm22.strLang(lang, 'Lead channel', 'Canale provenienza lead')" class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('flightLand')" />
          <select @change="save" class="input-elem com-anm22-app-select" v-model="contact.leadChannel">
            <option value>{{ $anm22.strLang(lang, 'No channel', 'Nessun canale') }}</option>
            <option
              v-for="(channel,index) in workChannels"
              :key="'channel-'+index"
              :value="channel.idContactsContactLeadChannel"
            >{{ channel.name }}</option>
          </select>
        </div>
        <div v-if="workCompetitors && workCompetitors.length > 0" class="wg-row detail-row ic-center">
          <img :title="$anm22.strLang(lang, 'Competitor', 'Competitor')" class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('stackedLineChart')" />
          <select @change="save" class="input-elem com-anm22-app-select" v-model="contact.competitor">
            <option value>{{ $anm22.strLang(lang, 'No competitor', 'Nessun competitor') }}</option>
            <option
              v-for="(competitor,index) in workCompetitors"
              :key="'competitor-'+index"
              :value="competitor.idContactsContactCompetitor"
            >{{ competitor.name }}</option>
          </select>
        </div>
        <div v-if="workReasonsAbandoned && workReasonsAbandoned.length > 0" class="wg-row detail-row ic-center">
          <img
            :title="'Stato abbandono'"
            class="com-anm22-app-img-fixed-height-m"
            :src="$anm22.icons.getWorldIcon('abandoned')"
          />
          <select @change="save" class="input-elem com-anm22-app-select" v-model="contact.abandoned">
            <option value>{{ $anm22.strLang(lang, 'No abbandoned', 'Non abbandonato') }}</option>
            <option
              v-for="(reason,index) in workReasonsAbandoned"
              :key="'r-'+index"
              :value="reason.idContactsContactAbandoned"
            >{{ reason.name }}</option>
          </select>
        </div>
        <!-- Customizzazione dettagli spiagge.it -->
        <template v-if="contact.workOwner == 6">
          <custom-details @save="save" :contacts="contacts" :contactData="contact"></custom-details>
        </template>
        <div v-if="contact.pauseDate" class="wg-row detail-row">
          <img :title="$anm22.strLang(lang, 'Pause', 'Contatto in pausa')" class="com-anm22-app-img-fixed-height-m" src="../../../../utilities/img/icons/pause.svg" />
          <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Waiting until', 'In attesa fino al')}}</span>{{ contact.pauseDate | moment('DD/MM/YYYY') }}</div>
        </div>
        <div v-if="contact.value && contact.value != 0" class="wg-row detail-row">
          <img :title="$anm22.strLang(lang, 'Lead value', 'Valore lead')" class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('cash')" />
          <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Lead value', 'Valore lead')}}</span>{{ contact.value}}</div>
        </div>
        <div v-if="contact.fbPage" class="wg-row detail-row">
          <img
            class="com-anm22-app-img-fixed-height-m"
            :src="$anm22.icons.getWorldIcon('facebook')"
          />
          <div
            v-if="contact.fbPage.indexOf('http://')>-1 || contact.fbPage.indexOf('https://')>-1 "
          >
            <a :href="contact.fbPage" target="_blank">
              <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Facebook page', 'Pagina Facebook')}}</span>{{ contact.fbPage }}</div>
            </a>
          </div>
          <div v-else>
            <a :href="'https://'+contact.fbPage" target="_blank">
              <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Facebook page', 'Pagina Facebook')}}</span>{{ 'https://'+ contact.fbPage }}</div>
            </a>
          </div>
        </div>
        <div v-if="contact.website" class="wg-row detail-row">
          <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('website')" />
          <div
            v-if="-1 !== contact.website.indexOf('http://') || -1 !== contact.website.indexOf('https://') "
          >
            <a :href="contact.website" target="_blank">
              <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Website', 'Sito web')}}</span>{{ contact.website }}</div>
            </a>
          </div>
          <div v-else>
            <a :href="'http://'+contact.website" target="_blank">
              <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Website', 'Sito web')}}</span>{{ 'http://'+ contact.website }}</div>
            </a>
          </div>
        </div>
        <div v-if="contact.sdi" class="wg-row detail-row">
          <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('sdi')" />
          <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'SDI code', 'Codice SDI')}}</span>{{ contact.sdi }}</div>
        </div>
        <div v-if="contact.mybusiness" class="wg-row detail-row">
          <img
            class="com-anm22-app-img-fixed-height-m"
            :src="$anm22.icons.getWorldIcon('mybusiness')"
          />
          <div class="com-anm22-app-text-l">{{ contact.mybusiness }}</div>
        </div>
        <div v-if="contact.taxCode" class="wg-row detail-row">
          <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('taxCode')" />
          <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Tax code', 'Codice fiscale')}}</span>{{ contact.taxCode }}</div>
        </div>
        <div v-if="contact.vatCode" class="wg-row detail-row">
          <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('vatCode')" />
          <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Vat Code', 'P.IVA')}}</span>{{ contact.vatCode }}</div>
        </div>
        <div v-if="(mainPlace.length > 0) && (typeof mainPlace[0] != 'undefined')" class="wg-row detail-row">
          <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('placeBlack')" />
          <div class="com-anm22-app-text-l"> {{ (mainPlace[0].name ? mainPlace[0].name + ', ' : '') + mapsAddress }}</div>
        </div>
        <div v-if="contact.privacyPolicyDate" class="wg-row detail-row">
          <img :title="'Privacy Policy'" class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('privacyPolicy')" />
          <div class="com-anm22-app-text-l"><span class="detail-label">{{ $anm22.strLang(lang, 'Privacy policy', 'Accetazione privacy')}}</span>{{ contact.privacyPolicyDate | moment('DD/MM/YYYY') }}</div>
        </div>
        <div v-if="contact.commercialPrivacyPolicyDate" class="wg-row detail-row">
          <img :title="$anm22.strLang(lang, 'Privacy Policy (Commercial)', 'Privacy Policy (Commerciale)')" class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('privacyPolicy')" />
          <div class="com-anm22-app-text-l">{{ $anm22.strLang(lang, '(Commercial)', '(Commerciale)') }}</div>
          <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
          <div class="com-anm22-app-text-l">{{ contact.commercialPrivacyPolicyDate | moment('DD/MM/YYYY') }}</div>
        </div>
        <div v-if="contact.workOwner == 16" class="wg-row detail-row">
          <img class="com-anm22-app-img-fixed-height-m" :src="$anm22.icons.getWorldIcon('website')" />
          <div v-if="!showVircosDealerToken" class="com-anm22-app-text-l" style="cursor: pointer" @click="showVircosDealerToken = true"><span class="detail-label">{{ $anm22.strLang(lang, 'Widget ID', 'Widget ID')}}</span>●●●●●●●●</div>
          <div v-if="showVircosDealerToken" class="com-anm22-app-text-l" style="word-break: break-word;"><span class="detail-label">{{ $anm22.strLang(lang, 'Widget ID', 'Widget ID')}}</span>{{ vircosDealerToken }}</div>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:25px;"></div>
    <!-- CONTATTI AZIENDALI -->
    <template v-if="contact.type == 2">
      <div
        class="com-anm22-app-text-xxl"
      >{{ $anm22.strLang(lang, 'Company contacts', 'Contatti aziendali') }}</div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div
        v-for="(contact,index) in companyContacts"
        :key="'c-contact-'+index"
        class="wg-row detail-row"
      >
        <div class="container">
          <img
            :src="$anm22.getContactIcon(contact, $store)"
            class="com-anm22-app-img-fixed-height-m"
          />
        </div>
        <div class="wg-row">
          <div style="font-size:16px" class="wg-row">{{ $anm22.getContactName(contact, $store) }}</div>
          <div
            v-if="contact.otherContacts && contact.otherContacts.job"
            class="wg-col wg-xs-12 wg-sm-12"
          >
            <small>{{ $anm22.strLang(lang, 'Job :', 'Mansione :' + contact.otherContacts.job ) }}</small>
          </div>
          <div v-if="contact.email && contact.email != ''" class="wg-col wg-xs-12 wg-sm-12">
            <small>Email: {{contact.email}}</small>
          </div>
          <div v-if="contact.phoneAreaCode && contact.phoneAreaCode != '' && contact.phoneNumber && contact.phoneNumber != ''" class="wg-col wg-xs-12 wg-sm-12">
            <small>Tel: {{ contact.phoneAreaCode + contact.phoneNumber}}</small>
          </div>
        </div>
        <div class="wg-col wg-xs-12 wg-sm-12">
          <img
            :src="$anm22.icons.getWorldIcon('openApp')"
            :title="$anm22.strLang(lang, 'Open contact', 'Apri contatto')"
            class="com-anm22-app-img-fixed-height-m"
            @click="$router.push({ path: `/contact/${contact.idContactsContact}` });"  
            style="margin-left:20px;cursor:pointer;"
          />
        </div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <input
        type="button"
        class="small"
        :value="$anm22.strLang(lang, 'New contact', 'Nuovo contatto')"
        @click="showDialog"
      />
      <div class="vertical-height-div" style="height:25px;"></div>
    </template>
    <template v-if="contact.workOwner && contact.workOwner != 0">
      <div class="wg-row">
        <div
          class="com-anm22-app-text-xxl"
        >{{ $anm22.strLang(lang, 'Contact accountable', 'Responsabile contatto') }}</div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <template v-if="!contact.referenceAgent">
        <template v-if="canRemoveReferent">
          <wg-search
            :placeholder="$anm22.strLang(lang, 'User', 'Utente')"
            :url="'user/getByNameWithWork'"
            :clickFn="addUser"
            :attachedData="{work: contact.workOwner}"
            :debounceTime="2000"
          ></wg-search>
        </template>
        <template v-else>
          <input
            disabled
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'User', 'Utente')"
          />
        </template>
      </template>
      <!-- Referente contatto -->
      <template v-if="contact.referenceAgent">
        <!-- List of users -->
        <div
          class="wg-row"
          style="align-items:center;"
        >
          <div style="min-width:35px;width:35px;height:35px;margin-right:6px;">
            <world-object-icon :type="'user'" :obj="$store.getters['users/get'](contact.referenceAgent)" :isImg="true"></world-object-icon>
          </div>
          <div>
            <div
              class="com-anm22-app-text-l"
              style="font-weight:bold;"
            >{{ $store.getters['users/get'](contact.referenceAgent).name + ' ' + $store.getters['users/get'](contact.referenceAgent).surname }}</div>
            <div class="vertical-height-div" style="height:2px;"></div>
            <div v-if="canRemoveReferent"
              class="display-flex"
              style="flex-wrap:nowrap;align-items:center;cursor:pointer;"
              @click="removeUser"
            >
              <img
                class="com-anm22-app-img-fixed-height-s"
                :src="$anm22.icons.getWorldIcon('deleteBlack')"
              />
              <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}</div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </div>
      </template>
      <div class="vertical-height-div" style="height:25px;"></div>
    </template>
    <!-- referent screen sales -->
    <template v-if="contact.workOwner && contact.workOwner != 0">
      <div class="wg-row">
        <div
          class="com-anm22-app-text-xxl"
        >{{ $anm22.strLang(lang, 'Referent screen sales', 'Referente screen sales') }}</div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <template v-if="!contact.screenSalesAgent">
        <template v-if="canRemoveScreenSales">
          <wg-search
            :placeholder="$anm22.strLang(lang, 'User', 'Utente')"
            :url="'user/getByNameWithWork'"
            :clickFn="addScreenSalesUser"
            :attachedData="{work: contact.workOwner}"
            :debounceTime="2000"
          ></wg-search>
        </template>
        <template v-else>
          <input
            disabled
            class="input-elem com-anm22-app-input-text"
            type="text"
            :placeholder="$anm22.strLang(lang, 'User', 'Utente')"
          />
        </template>
      </template>
      <!-- screen sales contatto -->
      <template v-if="contact.screenSalesAgent">
        <!-- List of users -->
        <div
          class="wg-row"
          style="align-items:center;"
        >
          <div style="min-width:35px;width:35px;height:35px;margin-right:6px;">
            <world-object-icon :type="'user'" :obj="$store.getters['users/get'](contact.screenSalesAgent)" :isImg="true"></world-object-icon>
          </div>
          <div>
            <div
              class="com-anm22-app-text-l"
              style="font-weight:bold;"
            >{{ $store.getters['users/get'](contact.screenSalesAgent).name + ' ' + $store.getters['users/get'](contact.screenSalesAgent).surname }}</div>
            <div class="vertical-height-div" style="height:2px;"></div>
            <div v-if="canRemoveScreenSales"
              class="display-flex"
              style="flex-wrap:nowrap;align-items:center;cursor:pointer;"
              @click="removeScreenSalesUser"
            >
              <img
                class="com-anm22-app-img-fixed-height-s"
                :src="$anm22.icons.getWorldIcon('deleteBlack')"
              />
              <div class="com-anm22-app-horizontal-space" style="width:5px;"></div>
              <div class="com-anm22-app-text-m">{{ $anm22.strLang(lang, 'Remove', 'Rimuovi') }}</div>
            </div>
          </div>
          <div class="vertical-height-div" style="height:10px;"></div>
        </div>
      </template>
      <div class="vertical-height-div" style="height:25px;"></div>
    </template>
    <template v-if="contact.workOwner && contact.workOwner != 0 && contactsStatus.length > 0">
      <div class="wg-row">
        <div
          class="com-anm22-app-text-xxl"
        >{{ $anm22.strLang(lang, 'Contact status', 'Stato contatto') }}</div>
      </div>
      <div class="vertical-height-div" style="height:10px;"></div>
      <div class="wg-row" style="align-items:center;">
        <select class="input-elem com-anm22-app-select" v-model="selectedContactStatus" data-cy=contact-status-select>
          <option value>{{ $anm22.strLang(lang, 'No status', 'Nessuno stato') }}</option>
          <option
            v-for="(status,index) in orderedContactsStatusList"
            :key="'status-'+index"
            :value="status.idContactsContactStatus"
          >{{ status.name }}</option>
        </select>
        <div class="vertical-height-div wg-md-none" style="height:5px;"></div>
        <input
          style="margin-left:5px;"
          type="button"
          :value="$anm22.strLang(lang,'Save','Salva')"
          class="small"
          @click="changeStatus"
          data-cy=details-button-save
          />
      </div>
      <div class="vertical-height-div" style="height:24px;"></div>
    </template>
    <div class="wg-row">
      <div
        class="com-anm22-app-text-xxl"
      >{{ $anm22.strLang(lang, 'Manage links', 'Gestione links') }}</div>
    </div>
    <div class="widgets-box com-anm22-app-custom-scroll">
      <template v-if="contact.links.length > 0">
        <world-links
          :links="contact.links"
          @removeLink="deleteContactLink"
        ></world-links>
      </template>
      <div
        class="display-flex link-buttons"
        style="align-items: center; flex-wrap: nowrap"
      >
        <div class="wg-row icons" style="padding-top:5px;">
          <div  @click="openLinkModal = true" class="icon-div">
            <img
              class="com-anm22-app-img-fixed-height-m"
              style="padding: 5px; height: 100%"
              :title="$anm22.strLang(lang, 'Add link', 'Aggiungi link')"
              :src="$anm22.icons.getWorldIcon('link')"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="vertical-height-div" style="height:24px;"></div>
    <div class="wg-row">
      <div
        class="com-anm22-app-text-xxl"
      >{{ $anm22.strLang(lang, 'Advanced options', 'Opzioni avanzate') }}</div>
    </div>
    <div class="vertical-height-div" style="height:12px;"></div>
    <input
      type="button"
      class="small"
      :value="$anm22.strLang(lang, 'Merge contact', 'Fondi contatto')"
      @click="mergeContactDialog = true"
    />
  </div>
</template>

 <script>
import _ from "lodash";
import { mapState } from "vuex";
import CustomDetails from "../custom/spiagge/CustomDetails.vue";
import WorldContactForm from "../../../../../world/spa/components/WorldContactForm.vue";
import WorldAddLink from "../../../../../world/spa/components/WorldAddLink.vue";
import WorldLinks from "../../../../../world/spa/components/WorldLinks.vue";
import MergeContact from "../MergeContact.vue";

export default {
  props: {
    contact: Object
  },
  data() {
    return {
      //Oggetto da passare come riferimento per aggiunta rapida(contatto azienda)
      newCompanyContact: {
        type: 1,
        company: this.contact.firstName,
        workOwner: this.contact.workOwner,
        otherContacts: []
      },
      oldContactStatus:"",
      selectedContactStatus:"",
      mergeConfirmDialog:false,
      mergeContactDialog:false,
      showNewDialog: false,
      showTagDialog: false,
      newTag: {
        color: "#5291ff",
        label: ""
      },
      openLinkModal:false,
      tagSelectFilterString: "",
      showColors: false,
      showVircosDealerToken: false,
      tagColors: [
        {
          name: this.$anm22.strLang(this.lang, "Gray", "Grigio"),
          color: "#999"
        },
        {
          name: this.$anm22.strLang(this.lang, "Blue", "Blu"),
          color: "#5291ff"
        },
        {
          name: this.$anm22.strLang(this.lang, "Purple", "viola"),
          color: "purple"
        },
        { name: this.$anm22.strLang(this.lang, "Red", "Rosso"), color: "red" },
        {
          name: this.$anm22.strLang(this.lang, "Orange", "Arancione"),
          color: "orange"
        },
        {
          name: this.$anm22.strLang(this.lang, "Yellow", "Giallo"),
          color: "yellow"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      lang: state => state.lang,
      user: (state) => state.auth.user,
      windowWidth: state => state.windowWidth,
      offline: state => state.offline.isOffline
    }),
    workChannels() {
      return this.$store.getters['contactsLeadChannel/getByWork'](this.contact.workOwner)
    },
    workCompetitors() {
       return this.$store.getters['contactsCompetitors/getByWork'](this.contact.workOwner)
    },
    workReasonsAbandoned() {
      return this.$store.getters['contactsAbandoned/getByWork'](this.contact.workOwner)
    },
    statusChangedText() {
        let text = "";
        //VECCHIO STATO
        let fromStatus = this.$store.getters['contactsStatus/get'](this.oldContactStatus);
        //STATO SELEZIONATO
        let toStatus = this.$store.getters['contactsStatus/get'](this.selectedContactStatus);
        if(!fromStatus && toStatus ) {
          text = this.$anm22.strLang(this.lang, 'Contact added to' + ' ' + toStatus.name , 'Contatto aggiunto in'  + ' ' + toStatus.name)
        } else if(fromStatus && !toStatus) {
          text = this.$anm22.strLang(this.lang, 'Contact status removed ','Stato del contatto rimosso')
        } else if(fromStatus && toStatus) {
          text = this.$anm22.strLang(this.lang, 'Contact status changed to' + ' ' + toStatus.name, 'Lo stato del contatto è cambiato in' + ' ' + toStatus.name)
        }
        return text;
    },
    mapsAddress() {
      return this.$anm22.getAddressFromPlace(this, this.mainPlace[0]);
    },
    contactsStatus() {
      return this.$store.getters["contactsStatus/getByWork"](this.contact.workOwner);
    },
    orderedContactsStatusList() {
      var status = this.contactsStatus;
      status.sort(function(a, b) {
        if (a.level < b.level) {
          return -1;
        } else if (a.level > b.level) {
          return 1;
        } else {
          return 0;
        }
      });
      return status;
    },
    workContact() {
      if (this.contact.type == 2) {
        return false;
      }
      if (this.contact.companyContact) {
        const companyContact = this.$store.getters['contacts/get'](this.contact.companyContact);
        if (!companyContact.deleted) {
          return this.$store.getters['contacts/get'](this.contact.companyContact);
        }
      }
      if (this.contact.company) {
        return this.contacts.find(
          c =>
            c.type == 2 &&
            c.workOwner == this.contact.workOwner &&
            c.firstName.toUpperCase() == this.contact.company.toUpperCase() &&
            !c.deleted
        );
      }
      return false;
    },
    canAdd() {
      if (
        this.tags.find(
          t => t.label.toUpperCase() == this.newTag.label.toUpperCase()
        )
      ) {
        return false;
      } else {
        return true;
      }
    },
    mainPlace() {
      if (this.contact) {
        return this.$store.getters["contactPlaceAssocs/getByContact"](
          this.contact.idContactsContact
        )
          .filter(assoc => assoc.isMain)
          .map(a => this.$store.getters["places/get"](a.place));
      } else {
        return [];
      }
    },
    tags() {
      if (this.contact.workOwner) {
        return this.$store.getters["tags/getAll"].filter(
          t => t.work === this.contact.workOwner
        );
      } else {
        return [];
      }
    },
    contacts() {
      return this.$store.getters["contacts/getAll"];
    },
    companyContacts() {
      if (this.contact.type == 2) {
        return this.contacts.filter(
          c =>
            c.workOwner == this.contact.workOwner &&
            !c.deleted &&
            (
              (c.company && c.company.toUpperCase() == this.contact.firstName.toUpperCase())
              || (c.companyContact && c.companyContact == this.contact.idContactsContact)
            )
        );
      }
    },
    tagsToSelect() {
      return this.tags
        .filter(
          t =>
            -1 !== t.label.search(new RegExp(this.tagSelectFilterString, "i"))
        )
        .sort(function(a, b) {
          var propA = a.label.toUpperCase();
          var propB = b.label.toUpperCase();

          return propA.localeCompare(propB);
        });
    },
    contactTags() {
      if (this.contact.tags.length > 0) {
        return this.contact.tags.map(tId =>
          this.$store.getters["tags/get"](tId)
        ).filter(t => t);
      } else {
        return [];
      }
    },
    userPermission() {
      return this.$store.getters["employments/getPermByWork"](
        this.contact.workOwner
      );
    },
    canRemoveReferent() {
      if(this.contact.referenceAgent && this.contact.referenceAgent != '') {
        if(this.userPermission <= 3) {
          return true;
        } else {
          if(this.contact.referenceAgent == this.user.idWorldUser) {
            return true; 
          } else {
              let userEmployment = this.$store.getters["employments/get"](this.contact.referenceAgent + "-" + this.contact.workOwner);
              if(userEmployment) {
                if (userEmployment.accountable == this.user.idWorldUser) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
          }
        }
      } else {
        return true;
      }
    },
    canRemoveScreenSales() {
      if(this.contact.screenSalesAgent && this.contact.screenSalesAgent != '') {
        if(this.userPermission <= 3) {
          return true;
        } else {
          if(this.contact.screenSalesAgent == this.user.idWorldUser) {
            return true; 
          } else {
              let userEmployment = this.$store.getters["employments/get"](this.contact.screenSalesAgent + "-" + this.contact.workOwner);
              if(userEmployment) {
                if (userEmployment.accountable == this.user.idWorldUser) {
                  return true;
                } else {
                  return false;
                }
              } else {
                return false;
              }
          }
        }
      } else {
        return true;
      }
    },
    vircosDealerToken() {
      const dealerId = this.contact.idContactsContact;
      const concatenatedString = dealerId + '.' + this.$anm22.MD5("vircos" + dealerId);
      return btoa(concatenatedString);ì
    }
  },
  methods: {
    save() {
      let additionalData = {emails:[],phones:[]};
      this.$http
        .post("contact/edit", {
          contact: this.contact,
          additionalData: additionalData
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store
            .dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact]
            })
            .then(() => {

            })
            .catch(error => console.log(error));
      })
    },
    selectColor(color) {
      this.newTag.color = color;
      this.showColors = false;
    },
    addUser(userId) {
      this.$http
        .post("contact/add-referent", {
          contactId: this.contact.idContactsContact,
          userId
        }, {
          withCredentials: true
        })
        .then(response => {
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf('contacts'), objs: [response.data.contact]
            })
        })
        .catch(error => {});
    },
    async removeUser() {
      try {
        const response = await this.$http.post("contact/remove-referent", {
          contactId: this.contact.idContactsContact
        }, {
          withCredentials: true
        });
        this.$store.dispatch("contacts/update", {
          vlf: this.$vlf("contacts"),
          objs: [response.data.contact]
        });
      } catch (e) {}
    },
    addScreenSalesUser(userId) {
      this.$http
          .post("contact/add-screen-sales-referent", {
            contactId: this.contact.idContactsContact,
            userId
          }, {
            withCredentials: true
          })
      .then(response => {
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf('contacts'), objs: [response.data.contact]
            })
        })
        .catch(error => {});
      /* try{
        const response = await this.$http
          .post("contact/add-screen-sales-referent", {
            contactId: this.contact.idContactsContact,
            userId
          }, {
            withCredentials: true
          });
        this.$store.dispatch("contacts/update", {
          vlf: this.$vlf("contacts"),
          objs: [response.data.contact]
        });

      }catch(e){
        console.log(e)
      } */
    },
    async removeScreenSalesUser(userId) {
      try{
        const response = await this.$http
          .post("contact/remove-screen-sales-referent", {
            contactId: this.contact.idContactsContact,
            userId
          }, {
            withCredentials: true
          });
        this.$store.dispatch("contacts/update", {
          vlf: this.$vlf("contacts"),
          objs: [response.data.contact]
        });

      }catch(e){
        console.log(e)
      }
    },
    async changeStatus() {
      let msgData = {
        text: this.statusChangedText,
        description: "",
        type: "changeStatus",
        contentType: "plain",
        fromStatus: this.oldContactStatus,
        toStatus:this.selectedContactStatus
      }
      try {
        const response = await this.$http.post("contact/change-status", {
          contactId: this.contact.idContactsContact,
          newStatus:this.selectedContactStatus,
          msgData:msgData
        }, {
          withCredentials: true
        });
        this.$store.dispatch("contacts/update", {
          vlf: this.$vlf("contacts"),
          objs: [response.data.contact]
        }),
        this.$store.dispatch("messages/update", {
          vlf: this.$vlf("messages"),
          objs: [response.data.message]
        });
        /* Messaggio creazione progetti */
        let engText = "";
        let itText = "";
        if(response.data.projects && response.data.projects.length > 0) {
          engText = " - Successfully created projects";
          itText = " - Progetti creati correttamente";
        }
        this.$anm22.eventBus.$emit("world-headbar-show-message", {
          text: this.$anm22.strLang(
            this.lang,
            "Contact status changed successfully" + engText,
            "Stato del contatto cambiato con successo" + itText
          ),
          type: "suggestion",
        });
      } catch (e) {
        console.log(e);
      } finally {
        this.$anm22.eventBus.$emit('wg-modal-close');
      }
    },
    async saveLink(links) {
      try {
        const response = await this.$http.post("contact/links", {
          contactId: this.contact.idContactsContact,
          links: links
        }, {
          withCredentials: true
        });
        this.$store.dispatch("contacts/update", {
          vlf: this.$vlf("contacts"),
          objs: [response.data.contact]
        });
      } catch (e) {
        this.contact.links = links;
        await Promise.all([
          this.$store.dispatch("contacts/update", {
            vlf: this.$vlf("contacts"),
            objs: [this.contact]
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "ContactsContact",
            _table: "contacts",
            mode: "edit",
            type: "obj",
            obj: this.contact
          })
        ]);
      } finally {
        this.openLinkModal = false;
      }
    },
    async deleteContactLink(index) {
      let links = this.contact.links;
      links.splice(index, 1);
      try {
        const response = await this.$http.post("contact/links", {
          contactId: this.contact.idContactsContact,
          links: links
        }, {
          withCredentials: true
        });
        this.$store.dispatch("contacts/update", {
          vlf: this.$vlf("contacts"),
          objs: [response.data.contact],
        });
      } catch (e) {
        await Promise.all([
          this.$store.dispatch("contacts/update", {
            vlf: this.$vlf("contacts"),
            objs: [this.contact],
          }),
          this.$store.dispatch("offline/saveSyncTuple", {
            _vue: this,
            _class: "ContactsContact",
            _table: "contacts",
            mode: "edit",
            type: "obj",
            obj: this.contact,
          }),
        ]);
      }
    },
    openTagDialog() {
      this.showTagDialog = true;
      this.newTag.color = "#5291ff"
      this.newTag.label = "";
      this.tagSelectFilterString = "";
    },
    showMessage() {
      this.$anm22.eventBus.$emit("world-headbar-show-message", {
        text: this.$anm22.strLang(
          this.lang,
          "Unable to delete tag from system",
          "Impossibile cancellare il tag dal sistema"
        ),
        type: "alarm"
      });
    },
    cantDelete(tag) {
      let boolean = false;
      let contactsWorkTags = this.contacts.filter(c => c.workOwner == tag.work);
      contactsWorkTags.forEach(c => {
        let find = false;
        if (c.tags && c.tags.length > 0) {
          c.tags.forEach(tId => {
            if (tId == tag.idWorldTag) {
              find = true;
            }
          });
          if (find) {
            boolean = true;
          }
        }
      });
      return boolean;
    },
    showDialog() {
      this.showNewDialog = true;
    },
    addTag(selected) {
      let tag, mode;
      if (selected) {
        tag = selected;
        mode = "select";
      } else {
        tag = this.newTag;
        mode = "new";
        tag.idWorldTag = tag.dbKey = this.$anm22.genLocalId();
      }
      this.$http
        .post("contact/addtag", {
          idContact: this.contact.idContactsContact,
          tag: tag,
          mode: mode
        }, {
          withCredentials: true
        })
        .then(response => {
          Promise.all([
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact]
            }),
            this.$store.dispatch("tags/update", {
              vlf: this.$vlf("tags"),
              objs: [response.data.tag]
            })
          ])
            .then(() => {
              this.showTagDialog = false;
              this.tagSelectFilterString = "";
            })
            .catch(error => console.log(error));
        })
        .catch(error => {
          /* Offline */
          /* Add tag to contact's tags */
          tag.work = this.contact.workOwner;
          this.contact.tags.push(tag.idWorldTag);
          Promise.all([
            mode === "new"
              ? this.$store.dispatch("tags/update", {
                  vlf: this.$vlf("tags"),
                  objs: [tag]
                })
              : Promise.resolve(),
            this.$store.dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [this.contact]
            }),
            mode === "new"
              ? this.$store.dispatch('offline/saveSyncTuple', {
                  _vue: this,
                  _class: "WorldTag",
                  _table: "tags",
                  mode: 'new',
                  type: 'obj',
                  obj: tag
                })
              // this.$anm22.saveSyncTuple(this, "WorldTag", "new", tag)
              : Promise.resolve(),
            // this.$anm22.saveSyncTuple(
            //   this,
            //   "ContactsContact",
            //   "edit",
            //   this.contact
            // )
            this.$store.dispatch('offline/saveSyncTuple', {
              _vue: this,
              _class: "ContactsContact",
              _table: "contacts",
              mode: 'edit',
              type: 'obj',
              obj: this.contact
            }),
          ]).then(() => {
            this.showTagDialog = false;
            this.tagSelectFilterString = "";
          });
        });
    },
    openNewContact(id) {
      this.showNewDialog = false;
      this.$router.push({ path: `/contact/${id}` });
    },
    openWorkContact() {
      if (this.workContact) {
        this.$router.push({ path: `/contact/${this.workContact.idContactsContact}` });
      } else {
        return;
      }
    },
    // Cancellazione associazione tag con contatto
    removeTag(tag) {
      this.$http
        .post("contact/removetag", {
          idContact: this.contact.idContactsContact,
          idWorldTag: tag.idWorldTag
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store
            .dispatch("contacts/update", {
              vlf: this.$vlf("contacts"),
              objs: [response.data.contact]
            })
            .catch(error => console.log(error));
        })
        .catch(error => {
          /* Offline */
          const index = this.contact.tags.findIndex(
            t => t === tag.idWorldTag
          );
          if (-1 !== index) {
            this.contact.tags.splice(index, 1);
            Promise.all([
              this.$store.dispatch("contacts/update", {
                vlf: this.$vlf("contacts"),
                objs: [this.contact]
              }),
              // this.$anm22.saveSyncTuple(
              //   this,
              //   "ContactsContact",
              //   "edit",
              //   this.contact
              // )
              this.$store.dispatch('offline/saveSyncTuple', {
                _vue: this,
                _class: "ContactsContact",
                _table: "contacts",
                mode: 'edit',
                type: 'obj',
                obj: this.contact
              }),
            ]);
          }
        });
    },
    // Cancellazione tag dal sistema
    deleteTag(tag) {
      this.$http
        .post("contact/deletetag", {
          idWorldTag: tag.idWorldTag
        }, {
          withCredentials: true
        })
        .then(response => {
          if(!response.data.error) {
            this.$store
              .dispatch("tags/delete", {
                vlf: this.$vlf("tags"),
                obj: response.data.tag
              })
              .catch(error => console.log(error));
          } else {
            this.showMessage();
          }
        })
        .catch(error => {
         console.log(error);
        });
    }
  },
  components: {
    WorldContactForm,
    WorldAddLink,
    CustomDetails,
    WorldLinks,
    MergeContact
  },
  created() {
    this.$store.dispatch("tags/load", this.$vlf("tags")).then(() => {
      this.$http
        .get("contact/tags")
        .then(response => {
          this.$store
            .dispatch("tags/update", {
              vlf: this.$vlf("tags"),
              objs: response.data.tags,
              cleanFilters:[]
            })
            .then(() => {})
            .catch(error => console.log(error));
        })
        .catch(error => console.log(error));
    })
    if(this.contact.status == 0) {
      this.contact.status = "";
    }
    //Stato contatto(memorizziamo quello vecchio in oldContactStatus e selectedContactStatus lo utilizziamo nella select)
    this.selectedContactStatus = this.contact.status;
    this.oldContactStatus = this.contact.status;
  }
};
</script>
 
<style lang="scss" scoped>
.icon-div {
  border-radius: 30px;
  width: 60px;
  border: 1px solid #9999;
  height: 60px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  padding: 10px;
  cursor: pointer;
  &:hover {
    border: none;
    background-color: #eee;
  }
}
.widgets-box {
  overflow-x:auto;
  max-width:100%;
  white-space:nowrap;
  margin: 10px 0 0 0;
}
.widgets-box > div {
  display: inline-block;
  vertical-align: middle;
}
.detail-row {
  flex-wrap: nowrap;
  align-items: top;
  margin-bottom: 12px;

  &.ic-center {
    align-items: center;
  }

  & img {
    margin: 0 16px 0 10px;
  }

  .detail-label {
    display: block;
    font-size: 12px;
  }
}
// .image {
//   width: 40px;
//   height: 40px;
//   border: 1px solid #eee;
//   border-radius: 20px;
//   margin-right: 5px;
//   //box-sizing:content-box;
// }
.contact-tag {
  background-color: #ddd;
  font-size: 14px;
  padding: 10px;
  border-radius: 10px;
  margin: 5px 10px 5px 0;
  flex-wrap: nowrap;
  align-items: center;
}
.color-select {
  min-width: 50px;
  height: 36px;
  border: 1px solid #bbb;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
}
.color-selected {
  height: 100%;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
}
.color-list {
  flex-wrap: nowrap;
  background-color: #fff;
  position: absolute;
  top: 36px;
  z-index: 20;
  border: 1px solid #ddd;
  box-shadow: 0px 1px 5px #666;
  & > div {
    height: 36px;
    width: 50px;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    &:hover {
      background-color: #eee;
    }
    & > div {
      cursor: pointer;
      height: 12px;
      width: 12px;
      border-radius: 50%;
    }
  }
}
.tags-list {
  margin-top: 10px;
  min-height: 200px;
  height: 200px;
  border: 1px solid #bbb;
  border-radius: 4px;
  padding: 5px;
}
.tag-select {
  flex-wrap: nowrap;
  align-items: center;
  height: 36px;
  cursor: pointer;
  padding: 5px;
  &:hover {
    background-color: #eee;
  }
}
input[type="button"].add-tag {
  background: none;
  cursor: pointer;
  color: #333;
  font-weight: 500;
}
</style>
 